// getAutoChatMessageIds.js
'use strict';
import { Map } from 'immutable';
import { createSelector } from '../resource/createCachedSelector.js';

import getNotificationListData, {
  SortField,
  SortOrder,
} from '../selector/getNotificationListData.js';
import { notificationList } from '../resource/notificationConstants.js';
import { decodeUnicode } from '../resource/base64Utils.js';
import getIsAutoChatNotification from '../resource/getIsAutoChatNotification.js';

const defaultArray = [];
const defaultMap = new Map();

/**
 * Select auto chat message ids
 * @kind selector
 * @param {Immutable.Map} state - root state.
 * @return {array} The selected auto chat message ids.
 */
const getAutoChatMessageIds = createSelector(
  state =>
    getNotificationListData(
      state,
      notificationList.AUTO_CHAT,
      'itemIds',
      SortField.TIMESTAMP,
      SortOrder.ASC
    ),
  state => state.getIn(['notifications']),
  (notificationIds = defaultArray, notificationMap = defaultMap) => {
    const messageIds = notificationIds
      .filter(notificationId => {
        const tag = notificationMap.getIn([notificationId, 'data', 'tag']);
        const link = notificationMap.getIn([notificationId, 'data', 'link']);
        return getIsAutoChatNotification({ tag, link });
      })
      .map(notificationId => {
        const link = notificationMap.getIn([notificationId, 'data', 'link']);
        const url = new URL(link, 'http://localhost');
        const campaign = url.searchParams.get('campaign');
        if (campaign) {
          const decoded = JSON.parse(decodeUnicode({ str: campaign }));
          return decoded?.id;
        }
        return;
      })
      .filter(messageId => messageId);
    return messageIds;
  }
);

export default getAutoChatMessageIds;
